export default "__VITE_ASSET__N2mj1b5E__"